import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { requestPasswordResetWithLambda, resetPasswordWithLambda } from "../repository/authRepository";

const PasswordReset: React.FC = () => {
  const [searchParams] = useSearchParams();
  const resetToken = searchParams.get("token");
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState<string | null>(null);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleRequestReset = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    const result = await requestPasswordResetWithLambda(username);
    if ("error" in result) {
      setMessage(result.error);
      setIsError(true);
    } else {
      setMessage("Password reset email sent. Check your inbox.");
      setIsError(false);
      setUsername("");
    }
    setIsLoading(false);
  };

  const handleResetPassword = async (e: React.FormEvent) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setMessage("Passwords do not match");
      setIsError(true);
      return;
    }
    if (newPassword.length < 8) {
      setMessage("Password must be at least 8 characters");
      setIsError(true);
      return;
    }
    if (!resetToken) return;

    setIsLoading(true);
    const result = await resetPasswordWithLambda(resetToken, newPassword);
    if ("error" in result) {
      setMessage(result.error);
      setIsError(true);
    } else {
      setMessage("Password updated. Redirecting to login...");
      setIsError(false);
      setTimeout(() => navigate("/login"), 2000);
    }
    setIsLoading(false);
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2>Reset Password</h2>
        {message && <div className={isError ? "form-error" : "form-success"}>{message}</div>}

        {resetToken ? (
          <form onSubmit={handleResetPassword}>
            <div className="form-field">
              <label>New Password</label>
              <input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required minLength={8} />
            </div>
            <div className="form-field">
              <label>Confirm New Password</label>
              <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required minLength={8} />
            </div>
            <button type="submit" className="btn-primary full-width" disabled={isLoading}>
              {isLoading ? "Updating..." : "Update Password"}
            </button>
          </form>
        ) : (
          <form onSubmit={handleRequestReset}>
            <p className="muted">Enter your username and we'll send you a reset link.</p>
            <div className="form-field">
              <label>Username</label>
              <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} required />
            </div>
            <button type="submit" className="btn-primary full-width" disabled={isLoading}>
              {isLoading ? "Sending..." : "Send Reset Link"}
            </button>
          </form>
        )}

        <div className="auth-links">
          <a href="/login">Back to Login</a>
        </div>
      </div>
    </div>
  );
};

export default PasswordReset;
